// extracted by mini-css-extract-plugin
export default {"productGallery":"sI-z","inQuickShop":"tI-z"};